/**
 * @author: subhasish.ghosh@zoom.us
 */

import { useSelector } from "react-redux";

const useAuthentication = () => {
  return useSelector((state) => state.auth.isAuthenticated);
};

export default useAuthentication;
